module.exports = __webpack_public_path__ + "static/media/T08 - Spadari.ab16dc35.jpg";